<template>
  <div id="container" style="width: 100%" v-if="subgroupData">
    <h2 v-if="subgroupData.handleMode == 'WATCH'" class="text-center mb-4">
      {{ subgroupData.name }}
    </h2>
    <div v-else>
      <h2 v-if="subgroupData.handleMode != 'WATCH'" class="text-center mb-4">
        {{
          `${subgroupData.handleMode == 'CREATE' ? 'Crear' : 'Editar'} subgrupo`
        }}
      </h2>

      <v-text-field
        dense
        label="Nombre del subgrupo"
        filled
        rounded
        v-model="subgroupData.name"
      ></v-text-field>

      <v-menu
        v-model="memebersMenu"
        :close-on-content-click="false"
        offset-y
        max-height="500"
      >
        <template #activator="{ on, attrs }">
          <v-text-field
            v-model="searchCriteria"
            label="Buscar miembros"
            dense
            filled
            rounded
            clearable
            append-icon="mdi-magnify"
            v-bind="attrs"
            v-on="on"
            @click.prevent="openList"
          />
        </template>

        <v-list>
          <v-list-item
            v-for="member in organizationMembersList"
            :key="member._id + '_' + member.email"
            @click="selectMember(member)"
          >
            <div class="d-flex flex-column">
              <span class="font-weight-bold">
                {{ member.name }} {{ member.firstLastname }}
              </span>
              <span style="font-size: 12px">
                {{ member.email }}
              </span>
            </div>
          </v-list-item>

          <!-- Infinite scroll sentinel -->
          <v-list-item v-if="hasMore">
            <div v-intersect="handleScroll" class="d-flex justify-center py-2">
              <v-progress-circular v-if="loading" indeterminate size="20" />
            </div>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>

    <v-card
      max-height="300px"
      style="overflow-y: scroll"
      elevation="0"
      class="card-border"
      v-if="subgroupData.members.length > 0"
    >
      <div v-for="member in subgroupData.members" :key="member._id">
        <v-hover v-slot="{ hover }">
          <v-card width="100%" elevation="0" class="pa-4">
            <v-sheet class="d-flex" color="transparent">
              <div class="d-flex align-center">
                <v-avatar size="30" class="mr-4">
                  <v-img
                    :src="getProfilePicture(member)"
                    :alt="`member-${member._id}`"
                  />
                </v-avatar>
                <div class="d-flex flex-column">
                  <span class="font-weight-bold">
                    {{ `${member.name} ${member.firstLastname}` }}
                  </span>
                  <span>{{ member.email }}</span>
                </div>
              </div>
              <v-btn
                v-if="subgroupData.handleMode != 'WATCH'"
                fab
                elevation="0"
                small
                icon
                :color="hover ? 'red' : ''"
                class="ml-auto"
                @click="removeMemberFromSelected(member)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-sheet>
          </v-card>
        </v-hover>
      </div>
    </v-card>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    subgroupData: {
      type: Object,
      default: () => ({
        _id: null,
        name: '',
        members: [],
        handleMode: 'EDIT', // CREATE, EDIT, WATCH
      }),
    },
  },
  data() {
    return {
      page: 1,
      searchCriteria: '',
      hasMore: true,
      organizationMembersList: [],
      memebersMenu: false,
      loading: false,
      searchTimeout: null,
    };
  },

  watch: {
    searchCriteria(val, old) {
      if (val === old) return;

      clearTimeout(this.searchTimeout);

      // debounce
      this.searchTimeout = setTimeout(() => {
        this.resetAndFetch();
      }, 300);
    },

    memebersMenu(val) {
      if (val) {
        this.resetAndFetch();
      }
    },
  },

  methods: {
    openList() {
      this.memebersMenu = true;
    },

    resetAndFetch() {
      this.page = 1;
      this.hasMore = true;
      this.organizationMembersList = [];
      this.getMemberList();
    },

    async getMemberList() {
      if (!this.hasMore || this.loading) return;

      this.loading = true;

      try {
        const response = await axios.get('/users/subgroup-list', {
          params: {
            page: this.page,
            search: this.searchCriteria,
            excluded_ids: [...this.subgroupData.members].map((m) => m._id),
          },
        });

        const newMembers = response.data.docs || [];

        this.organizationMembersList = [
          ...this.organizationMembersList,
          ...newMembers,
        ];

        this.hasMore = response.data.hasNextPage;
        this.page++;
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    async handleScroll(entries) {
      const isIntersecting = entries[0]?.isIntersecting;
      if (!isIntersecting) return;
      if (!this.memebersMenu) return;
      if (!this.hasMore) return;
      if (this.loading) return;

      await this.getMemberList();
    },

    selectMember(member) {
      this.subgroupData.members = [member, ...this.subgroupData.members];
      this.memebersMenu = false;
    },

    removeMemberFromSelected(member) {
      this.subgroupData.members = this.subgroupData.members.filter(
        (m) => m._id !== member._id,
      );
    },

    getProfilePicture(member) {
      const defaultProfile =
        'https://icons.veryicon.com/png/o/miscellaneous/rookie-official-icon-gallery/225-default-avatar.png';
      return member?.profilePicture && member?.profilePicture != 'NOT_ASSIGNED'
        ? member.profilePicture
        : defaultProfile;
    },
  },
};
</script>

<style scoped>
.card-border {
  border: 1px solid #8080805c;
}
</style>
